export * from './navigate-event';
export * from './component-event';
export var SDKEventType;
(function (SDKEventType) {
    SDKEventType["sdk"] = "helpcenter-preview-sdk";
    SDKEventType["setup"] = "helpcenter-preview-setup";
})(SDKEventType || (SDKEventType = {}));
//# sourceMappingURL=events.js.map